import { useClientRecordReviews } from "@/lib/clientRecordQueries";

export default function ReviewsTab({ workspaceId, memberId }) {
  const { data, isPending, isError } = useClientRecordReviews(workspaceId, memberId);

  if (isPending) return <p className="text-sm text-ink-soft" data-testid="client-360-reviews-loading">Loading reviews…</p>;
  if (isError) return <p className="text-sm text-red-600" data-testid="client-360-reviews-error">Couldn't load reviews.</p>;
  if (data.items.length === 0) return <p className="text-sm text-ink-soft" data-testid="client-360-reviews-empty">No reviews or testimonials submitted yet.</p>;

  return (
    <div className="space-y-3" data-testid="client-360-reviews-tab">
      {data.items.map((r) => (
        <div key={r.rsb_id} className="border border-ink/10 rounded-lg p-4 bg-white/50" data-testid={`client-360-review-${r.rsb_id}`}>
          <div className="flex items-center gap-4 mb-2 text-sm">
            <span className="text-ink-soft">Coach rating: <span className="text-ink font-medium">{r.coach_rating ?? "—"}/5</span></span>
            <span className="text-ink-soft">Programme rating: <span className="text-ink font-medium">{r.programme_rating ?? "—"}/5</span></span>
          </div>
          {Object.entries(r.answers || {}).map(([k, v]) => (
            <p key={k} className="text-sm text-ink mb-1"><span className="text-ink-soft">{k.replace(/_/g, " ")}:</span> {v}</p>
          ))}
          <p className="text-xs text-ink-soft mt-2">Submitted {new Date(r.submitted_at).toLocaleDateString("en-US", { timeZone: "America/Sao_Paulo" })}</p>
        </div>
      ))}
    </div>
  );
}
